module.exports = "<svg id=\"0c895368-3cb4-42ac-b401-0c8f8a22d53b\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 50 50\"><title>phone</title><path d=\"M15.22,31.53,6.63,42.41a.58.58,0,0,0,.09.81h0l6.55,5.25A6.41,6.41,0,0,0,18,49.84c1.63-.17,12.67-13.45,16.17-19.51a129.29,129.29,0,0,0,9-18.87A6.43,6.43,0,0,0,39.4,3.21l-7.82-3a.58.58,0,0,0-.75.33h0L25.69,13.4a.58.58,0,0,0,.32.75h0l4.38,1.71c-1.48,3.19-3.13,6.37-4.93,9.48l0,0c-1.79,3.09-3.71,6.11-5.73,9l-3.67-2.94a.58.58,0,0,0-.81.09l0,0ZM31.7,15.78h0Z\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/Phone.svg
// module id = /VDe
// module chunks = 1